import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setLocale } from '../../../routes/actions';
import App from '../components/App';

export default function AppContainer(props) {
  const routes = useSelector((state) => state.routes);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  function handleSetLocale(locale) {
    dispatch(setLocale(locale));
  }

  return (
    <App
      {...props}
      isLoading={routes.loading}
      user={routes.user}
      error={routes.error}
      locale={routes.locale}
      setLocale={(locale) => handleSetLocale(locale)}
    />
  );
}
